window.jQuery = window.$ = require('./lib/jquery-3.1.1.min.js');
require('./lib/angucomplete-alt/angucomplete-alt-master/angucomplete-alt.js');
require('./lib/angucomplete-alt/angucomplete-alt-master/angucomplete-alt.css');
require('./lib/bootstrap-tooltip/bootstrap-tooltip.js');
require('./lib/angular-ui-bootstrap/ui-bootstrap-tpls.min.js');
require('./lib/angular-ui-bootstrap/ui-bootstrap.js');

//require('bootstrap-tooltip');

require('../fonts/fonts.css');
require('../css/header.css');
require('../kids/css/header.css');
require('../css/main-page.css');
require('../kids/css/main-page.css');
require('../css/subject.css');
require('../css/map.css');
require('../css/about.css');
require('../css/story.css');
require('../kids/css/story.css');
require('../css/advancedSearch.css');
require('../css/404.css');

var angular = require('angular'),
    ngSanitize = require('angular-sanitize'),
    router = require('angular-ui-router'),
    controllers = require('./controllers/controllers.js'),
    directives = require('./directives/directives.js'),
    config = require('../../config/config.js');

module.exports =
    angular.module("agada", [router, "angucomplete-alt", ngSanitize, controllers, directives, config])
    .filter('removeHTMLTags', function () {
        return function (text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    })
    .filter('trusted', ['$sce', function ($sce) {
        var div = document.createElement('div');
        return function (text) {
            div.innerHTML = text;
            return $sce.trustAsHtml(div.textContent);
        };
    }]);





//////////////////
// WEBPACK FOOTER
// ./public/js/app.js
// module id = 0
// module chunks = 0